__turbopack_context__.v({
  "circle": "HeroScrollScene-module__s76rdG__circle",
  "circleLayer": "HeroScrollScene-module__s76rdG__circleLayer",
  "runway": "HeroScrollScene-module__s76rdG__runway",
  "slot": "HeroScrollScene-module__s76rdG__slot",
});
